import React from "react";
import Block1 from "../Block1";
import Block2 from "../Block2";
import SubHeading from "../SubHeading";

function DontMiss() {
  return (
    <>
      {/* BLOCK */}
      <div className="p-4 md:p-0 mb-6">
          <SubHeading text="don't miss" color="yellow-400" />


        <div className="flex flex-col md:flex-row py-4">
            {/* Inner Left */}
            <div className="w-full">
                <Block1 />
            </div>
            {/* Inner Right */}
            <div className="w-full">
                <Block2 />
                <Block2 />
                <Block2 />
                <Block2 />
            </div>

        </div>
      </div>
    </>
  );
}

export default DontMiss;
